export const UPDATE_IMAGE_VIEWER_DETAILS = "UPDATE_IMAGE_DETAILS";
export const GET_IMAGE_VIEWER_LIST = "GET_IMAGE_VIEWER_LIST";
export const CLOSE_IMAGE_VIEWER = "CLOSE_IMAGE_VIEWER";
export const FILL_INITIAL_DATA_IMAGE_VIEWER = "FILL_INITIAL_DATA_IMAGE_VIEWER";
